import { useEffect, useState } from "react";
import {object, string, number} from "yup";
import routesStore from "../store/routesSettings";
import { useHandleForm } from "./useHandleForm";

export const useApprovalState = (DEFAULT_VALUES) => {

  const [isLoadingState, setIsLoadingState] = useState(false);
    
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);

  const handleOpenApproveModal = () => {
    setOpenApproveModal(true);
    setOpenRejectionModal(false);
  }
  const handleOpenRejectionModal = () => {
    setOpenRejectionModal(true);
    setOpenApproveModal(false);
  }

  const handleCloseApproveModal = () => {
    setOpenApproveModal(false);
    setOpenRejectionModal(false);
  }

  const [approvalState, setApprovalState] = useState(null);
  const [approvalHistory, setApprovalHistory] = useState(null);

  const schema = object().shape({
    comment: approvalState?.nextStepParams?.commentConfirmRequired && openApproveModal ||
      approvalState?.nextStepParams?.commentRejectRequired && openRejectionModal ?
      string().required("Причина обязательна для заполнения") : string(),
    fileId: approvalState?.nextStepParams?.fileConfirmRequired && openApproveModal ||
      approvalState?.nextStepParams?.fileRejectRequired && openRejectionModal ?
      number().required("Вложение обязательно") : string()
  }).required();

  const approvalForm = useHandleForm(schema, DEFAULT_VALUES, {comment: true}, "all");
  const { getEntityApprovalState, sendEntityToApproval, startAgreement, getEntityApprovalHistory } = routesStore;
  const loadState = async () => {
    setIsLoadingState(true);
    try {
        const res = await getEntityApprovalState(DEFAULT_VALUES.entityName, DEFAULT_VALUES.entityId);
        // values.record.agreementStatus = { entityState: res.data.entityState, entityStateName: res.data.entityStateName };
        setApprovalState(res.data);
        // MOCK
        // Отправить на согласование
        // setApprovalState({"agreementNeeded":true,"nextStepAvailable":true,"nextStepParams":{"id":17,"routeId":7,"newStatus":"Согласовано","newStatusReject":"Отклонено","orderNum":1,"userGroupId":9,"userId":null,"commentRejectRequired":true,"fileRejectRequired":false,"commentConfirmRequired":false,"fileConfirmRequired":false,"userGroupName":"Сотрудник ГРБС","userFio":null},"id":0,"status":"Не согласован","statusDate":null,"userId":null,"userFio":null,"routeCompleted":false,"entityState":0,"entityStateName":"Черновик","file":null,"entityName":"Формы конструктора","entityId":10,"okDecision":false,"comment":null,"fileId":null});
        // Согласование c обязательным комментом
        // setApprovalState({"agreementNeeded":true,"nextStepAvailable":true,"nextStepParams":{"id":17,"routeId":7,"newStatus":"Согласовано","newStatusReject":"Отклонено","orderNum":1,"userGroupId":9,"userId":null,"commentRejectRequired":true,"fileRejectRequired":false,"commentConfirmRequired":true,"fileConfirmRequired":false,"userGroupName":"Сотрудник ГРБС","userFio":null},"id":0,"status":"Не согласован","statusDate":null,"userId":null,"userFio":null,"routeCompleted":false,"entityState":1,"entityStateName":"Отправлено на согласование","file":null,"entityName":"Справочники","entityId":900114,"okDecision":false,"comment":null,"fileId":null})
        // Согласование c необязательным комментом
        // setApprovalState({"agreementNeeded":true,"nextStepAvailable":true,"nextStepParams":{"id":17,"routeId":7,"newStatus":"Согласовано","newStatusReject":"Отклонено","orderNum":1,"userGroupId":9,"userId":null,"commentRejectRequired":true,"fileRejectRequired":false,"commentConfirmRequired":false,"fileConfirmRequired":false,"userGroupName":"Сотрудник ГРБС","userFio":null},"id":0,"status":"Не согласован","statusDate":null,"userId":null,"userFio":null,"routeCompleted":false,"entityState":1,"entityStateName":"Отправлено на согласование","file":null,"entityName":"Справочники","entityId":900114,"okDecision":false,"comment":null,"fileId":null})
    }
    catch(e) {
        console.log(e);
    } finally {
        setIsLoadingState(false);
    }
  }

  const loadHistory = async () => {
    const res = await getEntityApprovalHistory(DEFAULT_VALUES.entityName, DEFAULT_VALUES.entityId);
    setApprovalHistory(res.data);
  }

  const approveOrReject = async (okDecision = true) => {
    try {
      const values = approvalForm.getValues();
      values.okDecision = okDecision;
      await sendEntityToApproval(values);
      loadState();
      loadHistory();
      handleCloseApproveModal();
      approvalForm.reset();
    }
    catch (e) {

    }
  }

  const onStartAgreement = async () => {
    try {
      await startAgreement(DEFAULT_VALUES.entityName, DEFAULT_VALUES.entityId);
      loadState();
      loadHistory();
    }
    catch (e) {

    }
  }

  const onHandleFileChange = (fileList) => {
    approvalForm.setValue("fileId", (fileList[0]?.id ?? ''));
    approvalForm.trigger();
  }

  useEffect(()=>{
    if(DEFAULT_VALUES.entityId) {
        loadState();
        loadHistory();
    }
  },[DEFAULT_VALUES.entityId]);

  return {
    isLoadingState,
    approvalState,
    approvalHistory,
    approvalForm,
    openApproveModal,
    openRejectionModal,
    handleOpenApproveModal,
    handleOpenRejectionModal,
    approveOrReject,
    onStartAgreement,
    getEntityApprovalHistory,
    handleCloseApproveModal,
    onHandleFileChange,
  }
}